<template>
  <span v-if="value && value.length">
    <el-link @click="editImage">{{ btnText }}</el-link>
    <ProdImageEditorDrawer ref="editImagesRef" @on-save-batch="handleSaveBatch" />
    <!-- 旧版模板（保留注释，不删除）
    <EditorImage ref="editImagesRef" />
    -->
  </span>
</template>

<script>
import ProdImageEditorDrawer from '@/components/Uploads/ProdImageEditorDrawer.vue';
// 旧版导入（保留注释，不删除）
// import EditorImage from '@/components/Uploads/Editor/index';

export default {
  components: {
    ProdImageEditorDrawer,
    // 旧版组件注册（保留注释，不删除）
    // EditorImage,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    btnText: {
      type: String,
      default: '批量编辑当前图片',
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    refName: String,
    getWidthAndHeights: Function

  },
  methods: {
    editImage() {
      const imgUrlList = this.value.filter(Boolean);
      if(imgUrlList.length === 0){
        this.$message.warning('当前没有可编辑的图片!')
        return
      }
      const srcList = imgUrlList.map((url, index) => ({ name: `img_${index+1}`, url }));
      this.$refs.editImagesRef.method_open({
        srcList,
      });
    },
    /* 旧版实现（保留注释，不删除）
    editImage() {
      const imgUrlList = this.value.filter(Boolean);
      if(imgUrlList.length === 0){
        this.$message.warning('当前没有可编辑的图片!')
        return
      }
      let tasks = []
      if(this.refName && this.getWidthAndHeights) {
        const widthAndHeights = this.getWidthAndHeights(this.refName)
        tasks = imgUrlList.map((url, index) => {
          return {
            width: widthAndHeights[index]?.width || 800,
            height: widthAndHeights[index]?.height || 800,
            backgroundImage: url
          }
        })
      } else {
        tasks = imgUrlList.filter(Boolean).map(url => {
          return {
            width: 800,
            height: 800,
            backgroundImage: url
          }
        })
      }
      this.$refs.editImagesRef.method_open({
        tasks,
        okFn: urlList => {
          this.$emit('change', urlList);
        },
      });
    },
    */
    handleSaveBatch(payload) {
      const urls = (payload && Array.isArray(payload.urls)) ? payload.urls : [];
      this.$emit('change', urls);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>